import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=5bade529&scoped=true&v-ref%3AerrorModal=true"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"
import style0 from "./Errors.vue?vue&type=style&index=0&id=5bade529&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bade529",
  null
  
)

export default component.exports